import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { getHtmlRenderUrl } from '../../utils/isHtmlRenderMode';
import PDFViewer from '../pdf/PDFViewer';
import getPresentationSlideImages from '../../selectors/getPresentationSlideImages';
import getSharedLinkPageImages from '../../selectors/getSharedLinkPageImages';
import ViewPageDrawer from './ViewPageDrawer';
import HtmlViewer from './HtmlViewer';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContentAnchor = styled.div.withConfig({
  displayName: "ViewContent__StyledContentAnchor"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);
const ViewContent = ({
  file,
  presentation,
  sharedLink,
  pageDrawerOpen,
  isHtmlDocument = false
}) => {
  if (isHtmlDocument) {
    var _sharedLink$name;
    return /*#__PURE__*/_jsx(Flex, {
      position: "relative",
      backgroundColor: "fill-field-default",
      "data-test-id": "view-content",
      minBlockSize: "0",
      flex: 1,
      children: /*#__PURE__*/_jsx(HtmlViewer, {
        url: getHtmlRenderUrl(sharedLink),
        title: (_sharedLink$name = sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.name) !== null && _sharedLink$name !== void 0 ? _sharedLink$name : '',
        anchorId: MAIN_CONTENT_ANCHOR,
        sharedLinkId: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id
      })
    });
  }
  if (file === null) {
    return null;
  }
  const isUngatedToChirp = isChirpEnabled();
  const {
    name,
    branding,
    imagePlaceholders
  } = isUngatedToChirp ? {
    name: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.name,
    branding: sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.brandingMetadata,
    imagePlaceholders: getSharedLinkPageImages(sharedLink)
  } : {
    name: presentation === null || presentation === void 0 ? void 0 : presentation.get('name'),
    branding: presentation === null || presentation === void 0 ? void 0 : presentation.brandingMetadata,
    imagePlaceholders: getPresentationSlideImages(presentation)
  };
  return /*#__PURE__*/_jsxs(Flex, {
    position: "relative",
    backgroundColor: "fill-field-default",
    "data-test-id": "view-content",
    minBlockSize: "0",
    flex: 1,
    children: [/*#__PURE__*/_jsx(StyledContentAnchor, {
      "aria-label": name,
      tabIndex: 0,
      id: MAIN_CONTENT_ANCHOR
    }), /*#__PURE__*/_jsx(PDFViewer, {
      file: file,
      presentationName: name,
      imagePlaceholders: imagePlaceholders,
      branding: branding
    }), /*#__PURE__*/_jsx(ViewPageDrawer, {
      open: pageDrawerOpen,
      presentation: presentation,
      sharedLink: sharedLink
    })]
  });
};
export default ViewContent;